import type { BlogRoutes } from '../routes';
import { BLOG_DATA } from '../data-blog';

export function searchBlogPosts(
  posts: BlogRoutes[],
  query: string
): BlogRoutes[] {
  if (!query.trim()) return posts;

  const normalizedQuery = query.toLowerCase().trim();

  return posts.filter(slug => {
    const post = BLOG_DATA[slug];

    // Search in title
    if (post.title.toLowerCase().includes(normalizedQuery)) return true;

    // Search in excerpt
    if (post.excerpt.toLowerCase().includes(normalizedQuery)) return true;

    // Search in key takeaways
    return post.keyTakeaways.some(takeaway =>
      takeaway.title.toLowerCase().includes(normalizedQuery) ||
      takeaway.content.toLowerCase().includes(normalizedQuery)
    );
  });
}
